<template>
  <div>
    <div :class="{ border_bottom: show }" class="commentsButton">
      <div @click="toggleModal()">コメントする</div>
      <div class="iconWithNum" @click="toggleModal()">
        <img class="icon" src="/assets/img/common/chat.svg" />
        <div class="num">{{ comments.length }}</div>
      </div>
    </div>
    <div class="form community" v-if="show">
      <div class="bg" @click="closeModal"></div>
      <div class="box">
        <div class="contents_wrapper">
          <h3>コメント</h3>
          <div class="comments_wrapper">
            <ul>
              <li v-for="(comment, i) in comments" :key="i">
                <div class="iconWithMessage sp">
                  <div class="icon">
                    <img :src="src(comment.user.image_url)" />
                  </div>
                  <div>
                    <div class="name">{{ comment.user.name }}</div>
                    <div class="messageWrap">
                      <p class="message">
                        {{ comment.content }}
                      </p>
                      <div class="date">{{ comment.created_at }}</div>
                    </div>
                    <content-info
                        v-if="showInfo(comment)"
                        :user-id="comment.user_id"
                        :content-type="2"
                        :content-id="comment.id"
                    ></content-info>
                  </div>
                </div>
                <div class="reviewCard comments pc">
                  <div class="iconWithName">
                    <div class="icon">
                      <img :src="src(comment.user.image_url)" />
                    </div>
                    <div class="name">{{ comment.user.name }}</div>
                    <content-info
                        v-if="showInfo(comment)"
                        :user-id="comment.user_id"
                        :content-type="2"
                        :content-id="comment.id"
                    ></content-info>
                  </div>
                  <div class="text">
                    <p class="content">
                      {{ comment.content }}
                    </p>
                    <div class="date">{{ comment.created_at }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="text_forme">
            <div class="iconWithTextForm">
              <div class="icon"><img :src="src(image)" /></div>
              <form v-if="is_login">
                <input
                  v-model="params.content"
                  type="text"
                  placeholder="コメントする"
                  class="comment_input"
                  :class="{ error: errors.content }"
                />
                <button class="button agreeButton" :class="{ disabled: isDisabledButton }" @click.prevent="submit">投稿</button>
              </form>
              <form v-else>
                <community-comment-signup-appeal :is_login="is_login">
                  無料会員登録で<br />
                  コミュニティ機能が使えます
                </community-comment-signup-appeal>
              </form>
              <div v-if="showComplete">
                <post-complete
                  :showComplete="showComplete"
                  @input="showComplete = $event"
                ></post-complete>
              </div>
            </div>
            <p v-for="(error,i ) in errors.content" class="formError" :key="i">
              {{ error }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media screen and (min-width: 769px) {
  .community .box .comments_wrapper ul li {
    border: none;
    & + li {
      border-top: 1px solid #ccc;
    }
  }
  .community .reviewCard .content {
    word-break: break-word;
  }
}
@media screen and (max-width: 768px) {
  .form.community {
    .box {
      overflow: unset;
    }
    .contents_wrapper {
      display: grid;
      grid-template-rows: 6.5rem 45.4rem 8.3rem;
      .comments_wrapper {
        ul {
          height: 100%;
          padding-bottom: 0;
        }
        .iconWithMessage {
          .messageWrap {
            .message {
              word-break: break-word;
            }
          }
        }
      }
      .text_forme {
        position: unset;
        background: #fff;
      }
    }
  }
}
</style>

<script>
import vClickOutside from "click-outside-vue3";

export default {
  props: {
    comments: Object,
    shop_id: Number,
    parent_comment_id: Number,
    image_path: String,
    is_login: Boolean,
    user: Object
  },
  data() {
    return {
      show: false,
      showComplete: false,
      isDisabledButton: false,
      params: {
        shop_id: this.shop_id,
        parent_comment_id: this.parent_comment_id,
        content: "",
      },
      image: '',
      errors: {},
    };
  },
  mounted() {
    if (!this.$_.isEmpty(this.user)) {
      this.image = this.user.image_url;
    }
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    toggleModal() {
      if (this.show === true) {
        this.closeModal();
      } else {
        this.showModal();
      }
    },
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
    src(url) {
      if (this.$_.isEmpty(url)) {
        return "/img/aloco_img_2.svg";
      } else {
        return this.image_path + url;
      }
    },
    checkValidation() {
      // 必須チェック
      this.errors = {};

      // コメント
      if (this.params.content.length == 0) {
        this.errors.content = ["コメントは必須入力です。"];
      }
      if (this.params.content.length > 5000) {
        this.errors.content = ["5000文字以下で入力してください。"];
      }

      if (Object.keys(this.errors).length == 0) {
        return true;
      } else {
        return false;
      }
    },
    submit() {
      // 多重submit防止
      this.isDisabledButton = true

      if (this.checkValidation()) {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        let data = new FormData();
        data.append("shop_id", this.params.shop_id);
        data.append("parent_comment_id", this.params.parent_comment_id);
        data.append("content", this.params.content);
        this.$axios.post("/api/users/community/add", data, config).then(() => {
          this.params.content = "";
          this.showComplete = true
          this.isDisabledButton = false
        }).catch(e => {
          this.isDisabledButton = false
        })
      } else {
        this.isDisabledButton = false
      }
    },
    showInfo(comment) {
      if (this.user) {
        if (this.is_login && this.user.id !== comment.user_id) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    show(val) {
      if (!val) return;
    },
  },
};
</script>
<style lang="scss">
.form {
  .icon {
    img {
      width: 100%;
      height: 100%;
      max-width: 32px;
      aspect-ratio: 1;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  &.community {
    .box {
      .text_forme {
        .iconWithTextForm {
          .agreeButton {
            &.disabled {
              background: #aeaeae;
              border: none;
              color: #fff;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}
</style>
